import styled from 'styled-components'
import { BREAKPOINT_MEDIUM } from '@big-red-group/storefront-common-ui'

export const Wrapper = styled.div`
  position: relative;
  background: white;
  border-radius: 6px;
  padding: 20px;
`
export const Title = styled.span`
  display: block;
  font-weight: var(--font-bold);
  line-height: 1.4;
  margin-bottom: 25px;
  font-size: 16px;
`
export const Session = styled.h3`
  margin-bottom: 28px;

  &:not(:first-of-type) {
    margin-top: 40px;
  }
`
export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:not(:first-child) {
    margin-top: 16px;
  }
`
export const OptionInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`
export const OptionPriceWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
export const OptionName = styled.span`
  font-weight: var(--font-medium);
  margin-right: 10px;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  & span {
    color: grey;
    font-size: 12px;
  }

  @media (max-width: 1100px) {
    font-size: 14px;
  }
`
export const FromPrice = styled.span`
  font-weight: var(--font-regular);
  color: var(--sale);
  margin-right: 8px;
  text-decoration: line-through;
  font-size: 14px;
`
export const Price = styled.span<{ onSale?: boolean }>`
  font-weight: var(--font-regular);
  margin-right: 20px;
  font-size: 14px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 6px;

  ${({ onSale }) =>
    onSale &&
    `
    color: var(--sale);

    s {
      color: var(--text-primary-light);
      font-size: 90%;
    }
  `}
`
export const Quantity = styled.span`
  font-weight: var(--font-regular);
  margin: 0 12px;
  min-width: 20px;
  text-align: center;
  font-size: 14px;
`
export const Button = styled.button`
  cursor: pointer;
  font-weight: var(--font-medium);
  font-size: 18px;
  border: none;
  background: whitesmoke;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  width: 28px;
`
export const Flex = styled.div`
  display: flex;
  align-items: center;
`
